import { line, area, curveLinear } from 'd3-shape';

export function renderAreaSeries(parentElem, graph, panel, series, xScale, yScale) {

	const areaGenerator = area()
		.x(d => xScale(graph.config.xAxis.config.dataAccessor(d)))
		.y0(d => yScale(series.config.dataAccessor(d)[0]))
		.y1(d => yScale(series.config.dataAccessor(d)[1]))
		.defined(d => series.config.dataAccessor(d) !== null)
		.curve(series.config.curve || curveLinear);

	const lineGenerator = line()
		.x(d => xScale(graph.config.xAxis.config.dataAccessor(d)))
		.y(d => yScale(series.config.dataAccessor(d)[1]))
		.defined(d => series.config.dataAccessor(d) !== null)
		.curve(series.config.curve || curveLinear);

	const areaFill = parentElem.append('path')
		.attr('class', `hw_panel_graph_series hw_panel_graph_area_series hw_panel_graph_series_${series.config.name}`)
		.attr('d', areaGenerator(graph.config.data));

	if (series.config.color !== null) {
		areaFill.style('fill', series.config.color);
	}

	const areaBorder = parentElem.append('path')
		.attr('class', `hw_panel_graph_series hw_panel_graph_area_series_border hw_panel_graph_series_border_${series.config.name}`)
		.attr('d', lineGenerator(graph.config.data));

	if (series.config.color !== null) {
		areaBorder.style('stroke', series.config.color);
	}

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-series-area.js